import React, {useEffect} from "react";
import styles from "./FileDropzone.module.scss";
import RenderIf from "@/components/Global/RenderIf/RenderIf";
import {useDrag} from "@/hooks/useDrag/useDrag.js";

export default function FileDropzone({children, className = "", onDrop, onDragOverStateChange, allowedType}) {
  const {handleDrop, handleDragOver, handleDragOut, isDraggingOver} = useDrag({
    onDrop,
    onDragOverStateChange,
    allowedType,
  });
  const {handleDragOver: dragStart, handleDragOut: dragFinish, isDraggingOver: isDragging} = useDrag();

  useEffect(() => {
    window.addEventListener("dragover", dragStart);
    window.addEventListener("mouseup", dragFinish);
    window.addEventListener("drop", dragFinish);
    window.addEventListener("dragleave", dragFinish);

    return () => {
      window.removeEventListener("dragover", dragStart);
      window.removeEventListener("mouseup", dragFinish);
      window.removeEventListener("drop", dragFinish);
      window.removeEventListener("dragleave", dragFinish);
    };
  }, []);

  return (
    <div
      onDrop={handleDrop}
      onDragLeave={handleDragOut}
      onDragOver={handleDragOver}
      className={`${className} ${styles.dropzone} ${isDragging || isDraggingOver ? styles.isDragging : ""}`}>
      {children}
      <RenderIf isTrue={isDragging}>
        <div className={styles.overlay}>Drop file here</div>
      </RenderIf>
      <RenderIf isTrue={isDraggingOver}>
        <div className={`${styles.overlay} ${isDraggingOver ? styles.isDraggingOver : ""}`}>Drop file here</div>
      </RenderIf>
    </div>
  );
}
